import { focusableSelector } from './focusable-selector';

export const focusFirstFocusable = (element: HTMLElement | null | undefined) => {
	if (!element) return;
	const focusable = element.matches(focusableSelector)
		? element
		: element.querySelector<HTMLElement>(focusableSelector);

	if (focusable) {
		focusable.focus();
		return focusable;
	}
};
